import { render } from "./FooterComponent.vue?vue&type=template&id=158ecacc&scoped=true"
const script = {}

import "./FooterComponent.vue?vue&type=style&index=0&id=158ecacc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-158ecacc"]])

export default __exports__